<div class="flex flex-col h-full bg-white">
  <div class="flex h-3 mt-3 items-center pl-2 pr-2">
    <a routerLink="/" class="h-full w-full">
      <img class="h-full" src="/assets/images/lohi_dark.svg" />
    </a>
    <span class="flex items-center cursor-pointer text-gray-600 justify-end" (click)="closeMenu.next()"
      >esc&nbsp;<mat-icon class="text-gray-600">close</mat-icon></span
    >
  </div>
  <div class="flex flex-col pl-2 pr-2">
    <ng-container *ngIf="isInternal$ | async">
      <a
        routerLink="/internal"
        class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
        (click)="closeMenu.next()"
        ><span class="mr-1 col-span-1 h-2">🤐</span
        ><span class="text-sm text-gray-900 font-semibold col-span-6">INTERNAL</span>
      </a>
    </ng-container>
    <ng-container *lohiFeatureFlag="'maxPayLoop'">
      <div class="font-semibold">Long Haul</div>
      <a
        href="{{ isStage ? 'https://stage.web.5f.app' : 'https://web.5f.app' }}"
        class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
        (click)="closeMenu.next()"
        ><span class="text-sm text-gray-900 font-semibold col-span-6">Go back to Carrier Portal</span>
      </a>
    </ng-container>
    <ng-container *ngIf="(userInfo$ | async)?.isCompanyFiveFTourOnly === false">
      <div class="font-semibold">Short Haul</div>
      <ng-container *lohiIsAdmin="null; else nonAdminMenu">
        <!--<ng-container *lohiRelationship="['broker', 'carrier']">
          <a
            *ngIf="token$ | async as token"
            href="https://{{ isStage ? 'stage.' : '' }}freedom.5f.app/auth/login_with_token?token={{ token }}"
            class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
            (click)="closeMenu.next()"
          >
            <span class="mr-1 col-span-1 text-blue-500" style="height: 16px; width: 16px"
              ><mat-icon inline>qr_code_2</mat-icon></span
            ><span class="text-sm text-gray-900 font-semibold col-span-6">Freedom Referral Plan</span>
          </a>
        </ng-container>
        <a
          *lohiRelationship="['broker', 'carrier']"
          routerLink="/h2024/company_tracker"
          class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
          (click)="closeMenu.next()"
          ><img class="mr-1 col-span-1 h-2" src="./assets/images/2021_holiday_icon.svg" /><span
            class="text-sm text-gray-900 font-semibold col-span-6"
            >Holiday Program</span
          >
        </a>-->
        <a
          *lohiRelationship="['broker', 'carrier']"
          routerLink="/owner-dashboard"
          class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
          (click)="closeMenu.next()"
          ><img class="mr-1 col-span-1 h-2" src="./assets/images/dashboard.svg" /><span
            class="text-sm text-gray-900 font-semibold col-span-6"
            >Owner Dashboard</span
          >
        </a>
        <a
          *lohiRelationship="['saas']"
          routerLink="/cc-dashboard"
          class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
          (click)="closeMenu.next()"
          ><img class="mr-1 col-span-1 h-2" src="./assets/images/dashboard.svg" /><span
            class="text-sm text-gray-900 font-semibold col-span-6"
            >Owner Dashboard</span
          >
        </a>
        <a
          *lohiFeatureFlag="'customerForecast'"
          routerLink="/forecast"
          class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
          (click)="closeMenu.next()"
          ><img class="mr-1 col-span-1 h-2" src="./assets/images/forecast.svg" /><span
            class="text-sm text-gray-900 font-semibold col-span-6"
            >Forecast</span
          >
        </a>
        <a
          *lohiFeatureFlag="'assetDashboard'"
          routerLink="/asset-dashboard"
          class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
          (click)="closeMenu.next()"
          ><img class="mr-1 col-span-1 h-2" src="./assets/images/dashboard.svg" /><span
            class="text-sm text-gray-900 font-semibold col-span-6"
            >Asset Dashboard</span
          >
        </a>
        <a
          *ngIf="isInternal$ | async"
          routerLink="/ymt"
          class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
          (click)="closeMenu.next()"
          ><img class="mr-1 col-span-1 h-2" src="./assets/images/dashboard.svg" /><span
            class="text-sm text-gray-900 font-semibold col-span-6"
            >YMT</span
          >
        </a>
        <a
          *ngIf="isInternal$ | async"
          routerLink="/needs-recovery"
          class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
          (click)="closeMenu.next()"
          ><span class="material-icons text-blue-500 col-span-1 h-2 -ml-0.5">cached</span>
          <span class="text-sm text-gray-900 font-semibold col-span-6">Assets Need Recovery</span>
        </a>
        <a
          routerLink="/dashboard"
          class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
          (click)="closeMenu.next()"
          ><img class="mr-1 col-span-1 h-2" src="./assets/images/dashboard.svg" /><span
            class="text-sm text-gray-900 font-semibold col-span-6"
            >Driver Shifts</span
          >
        </a>
        <a
          *lohiFeatureFlag="'driverShiftMap'"
          routerLink="/map"
          class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
          (click)="closeMenu.next()"
          ><img class="mr-1 col-span-1 h-2" src="./assets/images/map.svg" /><span
            class="text-sm text-gray-900 font-semibold col-span-6"
            >On Shift Drivers Map</span
          >
        </a>
        <a
          routerLink="/kpis"
          class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
          (click)="closeMenu.next()"
          ><span class="mr-1 col-span-1 text-blue-500" style="height: 16px; width: 16px"
            ><mat-icon inline>insights</mat-icon></span
          ><span class="text-sm text-gray-900 font-semibold col-span-6">Carrier KPIs</span>
        </a>
        <ng-container *lohiFeatureFlag="'coaching'">
          <a
            routerLink="/coaching"
            class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
            (click)="closeMenu.next()"
            ><span class="mr-1 col-span-1 text-blue-500" style="height: 16px; width: 16px"
              ><mat-icon inline>people</mat-icon></span
            ><span class="text-sm text-gray-900 font-semibold col-span-6">Coaching</span>
          </a>
        </ng-container>
        <ng-container *lohiRelationship="'saas'">
          <a
            routerLink="/leaderboard"
            class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
            (click)="closeMenu.next()"
            ><span class="mr-1 col-span-1 text-blue-500" style="height: 16px; width: 16px"
              ><mat-icon inline>leaderboard</mat-icon></span
            ><span class="text-sm text-gray-900 font-semibold col-span-6">Driver Leaderboard</span>
          </a>
        </ng-container>
        <ng-container *lohiFeatureFlag="'scorecard'">
          <ng-container *lohiRelationship="'saas'">
            <a
              routerLink="/carrier-scorecard"
              class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
              (click)="closeMenu.next()"
              ><span class="mr-1 col-span-1 text-blue-500" style="height: 16px; width: 16px"
                ><mat-icon inline>leaderboard</mat-icon></span
              ><span class="text-sm text-gray-900 font-semibold col-span-6">Carrier Scorecard</span>
            </a>
          </ng-container>
        </ng-container>
        <ng-container *lohiFeatureFlag="'webShiftBooking'">
          <a
            routerLink="/booking"
            class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
            (click)="closeMenu.next()"
          >
            <span class="mr-1 col-span-1 text-blue-500" style="height: 16px; width: 16px"
              ><mat-icon inline>book_online</mat-icon></span
            ><span class="text-sm text-gray-900 font-semibold col-span-6">Shift Booking</span>
          </a>
        </ng-container>
        <a
          routerLink="/loads/list/completed"
          class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
          (click)="closeMenu.next()"
          ><img class="mr-1 col-span-1 h-2" src="./assets/images/billing.svg" /><span
            class="text-sm text-gray-900 font-semibold col-span-6"
            >Billing</span
          >
        </a>
        <a
          routerLink="/billing"
          class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
          (click)="closeMenu.next()"
          ><img class="mr-1 col-span-1 h-2" src="./assets/images/billing.svg" /><span
            class="text-sm text-gray-900 font-semibold col-span-6"
            >Billing Export</span
          >
        </a>
        <a
          routerLink="/notifications"
          class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
          (click)="closeMenu.next()"
          ><span class="mr-1 col-span-1 text-blue-500" style="height: 16px; width: 16px"
            ><mat-icon inline>notifications</mat-icon></span
          ><span class="text-sm text-gray-900 font-semibold col-span-6">Notifications</span>
        </a>
        <a
          routerLink="/drivers"
          class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
          (click)="closeMenu.next()"
          ><img class="mr-1 col-span-1 h-2" src="./assets/images/driver_management.svg" /><span
            class="text-sm text-gray-900 font-semibold col-span-6"
            >Manage Drivers</span
          >
        </a>
        <ng-container *lohiRelationship="['broker', 'carrier']">
          <a
            routerLink="/settlement"
            class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
            (click)="closeMenu.next()"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.8304 15.5065C13.4466 15.5094 14.0401 15.2758 14.4877 14.8544C14.9353 14.4329 15.2024 13.8559 15.2335 13.2435C15.2335 13.2333 15.2335 13.223 15.2335 13.2108L17.5648 10.6046C17.8016 10.3314 18.1349 10.1595 18.4957 10.1245C18.8564 10.0895 19.2168 10.1941 19.5021 10.4167C19.6433 10.5329 19.7597 10.6761 19.8445 10.8379C19.9292 10.9996 19.9805 11.1766 19.9954 11.3584C20.0104 11.5401 19.9886 11.7231 19.9313 11.8963C19.8741 12.0696 19.7826 12.2297 19.6622 12.3672L15.0078 17.6777C14.701 18.0276 14.3225 18.308 13.8977 18.5C13.4729 18.692 13.0117 18.7912 12.5451 18.7908H5.54917L4.33426 20L0 15.7945L3.10499 12.7308C3.73553 12.1071 4.52978 11.6726 5.39683 11.4772C6.26388 11.2818 7.16869 11.3333 8.00771 11.6258L8.68904 11.8648H12.8858C13.0629 11.8647 13.2381 11.9 13.4012 11.9687C13.5643 12.0373 13.7119 12.1379 13.8351 12.2644C13.9584 12.3909 14.0549 12.5407 14.1189 12.7051C14.1828 12.8694 14.2129 13.0449 14.2074 13.221C14.1848 13.5674 14.0292 13.8918 13.7729 14.1272C13.5166 14.3625 13.1791 14.4907 12.8304 14.4853H10.3123C10.1763 14.4853 10.0458 14.5391 9.94955 14.6349C9.85334 14.7306 9.79928 14.8605 9.79928 14.9959C9.79928 15.1313 9.85334 15.2612 9.94955 15.357C10.0458 15.4527 10.1763 15.5065 10.3123 15.5065H12.8304ZM10.2898 5.73529C10.6284 5.92634 10.9818 6.09026 11.3466 6.22549C11.5026 6.28676 11.6586 6.35008 11.8125 6.41748C11.9962 6.4956 12.1682 6.59871 12.3235 6.72386C12.4139 6.78544 12.4853 6.87082 12.5298 6.97046C12.5743 7.07011 12.59 7.18009 12.5754 7.28814C12.5607 7.39618 12.5161 7.49804 12.4466 7.58234C12.3771 7.66664 12.2855 7.73006 12.1819 7.76552C11.9035 7.88206 11.5986 7.92158 11.2994 7.8799C10.8058 7.82607 10.326 7.68351 9.88343 7.45915C9.79098 7.40231 9.68604 7.36867 9.57765 7.36111C9.33138 7.36111 9.25545 7.60825 9.21235 7.74101C9.13232 7.99632 9.06049 8.25368 8.99072 8.51103C8.87579 8.93178 8.94762 9.08905 9.34369 9.28105C9.77894 9.47774 10.2408 9.60987 10.7146 9.6732C10.7898 9.68146 10.8641 9.6972 10.9362 9.72018C10.9518 9.79884 10.958 9.87905 10.9547 9.95915V10.4636C10.9505 10.528 10.9601 10.5925 10.9828 10.653C11.0055 10.7134 11.0408 10.7684 11.0863 10.8143C11.1319 10.8602 11.1867 10.896 11.2471 10.9193C11.3075 10.9427 11.3722 10.9531 11.4369 10.9498H11.7858H12.1963C12.2595 10.9532 12.3228 10.9431 12.3817 10.9201C12.4407 10.8971 12.494 10.8617 12.538 10.8164C12.582 10.771 12.6157 10.7168 12.6367 10.6573C12.6578 10.5979 12.6658 10.5346 12.6601 10.4718C12.6601 10.3962 12.6601 10.3186 12.6601 10.2431C12.6601 10.0878 12.6601 9.93056 12.6601 9.77533C12.6601 9.6201 12.697 9.57108 12.8653 9.5241C13.4091 9.38196 13.894 9.07243 14.2505 8.63971C14.4806 8.36349 14.6466 8.04016 14.7367 7.69275C14.8268 7.34535 14.8388 6.98244 14.7718 6.6299C14.6964 6.25412 14.5387 5.8995 14.3099 5.59129C14.0811 5.28309 13.7869 5.0289 13.4481 4.84681C13.0622 4.64419 12.6648 4.46415 12.2578 4.3076L12.1019 4.24428C11.8635 4.14912 11.6397 4.02125 11.4369 3.86438C11.3668 3.81385 11.311 3.74607 11.275 3.66767C11.2391 3.58927 11.2242 3.50293 11.2317 3.41708C11.2481 3.32937 11.2872 3.24744 11.3452 3.17938C11.4031 3.11132 11.4779 3.05949 11.5621 3.029C11.685 2.98047 11.8158 2.95485 11.9479 2.95343C12.4907 2.92069 13.0328 3.02761 13.522 3.26389C14.0268 3.50694 14.1376 3.14134 14.1787 2.98611C14.2464 2.78186 14.3059 2.57761 14.3654 2.36315L14.4352 2.11806C14.4565 2.06046 14.4659 1.99919 14.4629 1.9379C14.4599 1.8766 14.4445 1.81654 14.4177 1.76127C14.3909 1.70601 14.3532 1.65668 14.3069 1.61621C14.2605 1.57575 14.2065 1.54498 14.1479 1.52574C13.8002 1.37305 13.4338 1.2666 13.0582 1.20915C12.7196 1.15605 12.7196 1.15605 12.7196 0.816993C12.7196 0.104167 12.6642 0 11.9644 0H11.5868C11.1763 0.0122549 11.0655 0.132761 11.0552 0.533088C11.0552 0.627043 11.0552 0.718954 11.0552 0.810866V0.959967C11.0552 1.26021 11.0552 1.26021 10.7556 1.36846C9.66384 1.76266 9.07691 2.50613 9.01124 3.57639C8.95172 4.47712 9.37243 5.18791 10.2898 5.73529Z"
                fill="#448AFF"
              />
            </svg>
            <span class="text-sm text-gray-900 font-semibold col-span-6">Carrier Settlements</span>
          </a>
        </ng-container>

        <ng-container *lohiRelationship="['broker', 'carrier']">
          <a
            routerLink="/sign-on-bonus"
            class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
            (click)="closeMenu.next()"
            ><span class="mr-1 col-span-1 text-blue-500" style="height: 16px; width: 16px"
              ><mat-icon inline>card_giftcard</mat-icon></span
            ><span class="text-sm text-gray-900 font-semibold col-span-6">Sign-on Bonuses</span>
          </a>
        </ng-container>

        <ng-container>
          <a
            routerLink="/manage-fleet/assets"
            class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
            (click)="closeMenu.next()"
          >
            <span class="material-icons text-blue-500">local_shipping</span>
            <span class="text-sm text-gray-900 font-semibold col-span-6">Manage fleet</span>
          </a>
        </ng-container>
        <ng-container *lohiFeatureFlag="'fuelCardList'">
          <a
            routerLink="/fuelcard"
            class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
            (click)="closeMenu.next()"
            ><img class="mr-1 col-span-1 h-2" src="./assets/images/fuel_card.svg" /><span
              class="text-sm text-gray-900 font-semibold col-span-6"
              >Fuel Cards</span
            >
          </a>
        </ng-container>
        <!--<ng-container *lohiRelationship="['broker', 'carrier']">
          <ng-container *lohiFeatureFlag="'lohiPay'">
            <a
              routerLink="/pay"
              class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
              (click)="closeMenu.next()"
              ><img class="mr-1 col-span-1 h-2" src="./assets/images/lohi_pay.svg" /><span
                class="text-sm text-gray-900 font-semibold col-span-6"
                >LoHi™ Pay</span
              >
            </a>
          </ng-container>
        </ng-container>-->
        <ng-container *lohiPayMerchant>
          <ng-container *lohiFeatureFlag="'lohiPay'">
            <a
              routerLink="/pay"
              class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
              (click)="closeMenu.next()"
              ><img class="mr-1 col-span-1 h-2" src="./assets/images/lohi_pay.svg" /><span
                class="text-sm text-gray-900 font-semibold col-span-6"
                >LoHi™ Pay</span
              >
            </a>
          </ng-container>
        </ng-container>
        <ng-container *lohiFeatureFlag="'driverSettlements'">
          <a
            routerLink="/driver_settlement"
            class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
            (click)="closeMenu.next()"
            ><img class="mr-1 col-span-1 h-2" src="./assets/images/driver_settlements.svg" /><span
              class="text-sm text-gray-900 font-semibold col-span-6"
              >Settlements by Driver</span
            >
          </a>
        </ng-container>

        <div class="border-b border-gray-400 mt-3"></div>
        <div id="releaseNotes" class="flex flex-col pr-2 pl-2">
          <div class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1">
            <span id="releaseNotesBadge"></span>
            <span class="text-sm text-gray-900 font-semibold col-span-6"> Release Notes </span>
          </div>
        </div>
      </ng-container>
      <ng-template #nonAdminMenu>
        <div *lohiIsDriver>
          <ng-container *lohiRelationship="['broker', 'carrier']">
            <div class="flex flex-col pr-2 pl-2" *lohiFeatureFlag="'lohiPay'">
              <a
                routerLink="/pay"
                class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
                (click)="closeMenu.next()"
                ><img class="mr-1 col-span-1 h-2" src="./assets/images/lohi_pay.svg" /><span
                  class="text-sm text-gray-900 font-semibold col-span-6"
                  >LoHi™ Pay</span
                >
              </a>
            </div>
          </ng-container>
          <ng-container *lohiRelationship="['broker', 'carrier']">
            <div class="flex flex-col pr-2 pl-2" *lohiFeatureFlag="'driverSettlementsInDriverMenu'">
              <a
                routerLink="/driver_settlement"
                class="items-center grid grid-cols-10 hover:bg-indigo-800 p-1 rounded mt-1"
                (click)="closeMenu.next()"
                ><img class="mr-1 col-span-1 h-2" src="./assets/images/driver_settlements.svg" /><span
                  class="text-sm text-gray-900 font-semibold col-span-6"
                  >My Settlements</span
                >
              </a>
            </div>
          </ng-container>
        </div>
      </ng-template>
    </ng-container>
  </div>
  <div class="absolute flex items-center p-1 bg-indigo-800 rounded w-full" style="bottom: 12px">
    <div class="flex flex-col pl-1 border-r border-gray-700 w-4/5" *ngIf="userInfo$ | async as userInfo">
      <span class="font-semibold text-sm">{{ userInfo.driverName }}</span>
      <span class="text-sm">{{ userInfo.companyName }}</span>
    </div>
    <div>
      <img
        class="absolute bottom-0 right-0 mr-3 mb-2 cursor-pointer"
        src="/assets/images/logout.svg"
        (click)="logout()"
      />
    </div>
  </div>
</div>
